import React, { useState, useEffect } from 'react';
import { Badge, Button, Form, InputGroup } from 'react-bootstrap';
import './StaffManagement.css';
import { oneKlicks } from '../../SDK/oneclick';
import MapSearchModal from '../Components/MapSearchModal';
import { FaMapMarkerAlt } from 'react-icons/fa';
import ImageShow from '../../Uitiles/ImageShow';

const Users = () => {
    const [staff, setStaff] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingStaff, setEditingStaff] = useState(null);
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        role: '',
        permissions: [],
        location: null,
        address: ''
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [isMapModalVisible, setIsMapModalVisible] = useState(false);

    // Sample permissions
    const permissions = [
        { label: 'View Dashboard', value: 'view_dashboard' },
        { label: 'Manage Appointments', value: 'manage_appointments' },
        { label: 'Manage Doctors', value: 'manage_doctors' },
        { label: 'Manage Staff', value: 'manage_staff' },
        { label: 'Manage Patients', value: 'manage_patients' },
        { label: 'Manage Settings', value: 'manage_settings' },
        { label: 'Manage Pharmacies', value: 'manage_pharmacies' },
       
        { label: 'View Profile', value: 'view_profile' },
        { label: 'View Inbox', value: 'view_inbox' },
        { label: 'Manage Profile', value: 'manage_profile' },
        { label: 'View Saved Items', value: 'view_saved_items' },
        { label: 'Manage Hospitals', value: 'manage_hospitals' },           
    ];

    useEffect(() => {
        
        fetchStaff();
    }, []);

    const fetchStaff = async () => {
        try {
            const tableSchema = '';
            const tableName = 'users';
            const conditions = {
                user_type: 'patient'
            };
            const orderBy = "id DESC";
            const search = '';
            const pagination = {};
            const margedata = {};
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                setStaff(response.data); 
            } else {
                console.error('Error fetching staff:', response.message);
            }
        } catch (error) {
            console.error('Error fetching staff:', error);
        }
    };

    const handleAdd = () => {
        setEditingStaff(null);
        setFormData({
            first_name: '',
            last_name: '',
            email: '',
            role: '',
            permissions: [],
            location: null,
            address: ''
        });
        setIsModalVisible(true);
    };

    const handleEdit = (record) => {
        setEditingStaff(record);
        console.log("record location :", record.location);
        //record location :
        setFormData({
            ...record,
            //location: record.location ? JSON.parse(record.location) : null,
            address: record.address || ''
        });
        setIsModalVisible(true);
    };

    const handleDelete = (id) => {
        setStaff(staff.filter(item => item.id !== id));
        alert('Staff member deleted successfully');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePermissionChange = (e) => {
        const options = e.target.options;
        const selectedPermissions = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selectedPermissions.push(options[i].value);
            }
        }
        setFormData(prev => ({
            ...prev,
            permissions: selectedPermissions
        }));
    };

    const handleLocationSelect = (locationData) => {
        setFormData(prev => ({
            ...prev,
            location: locationData.location,
            address: locationData.address
        }));
    };

    const handleMapSearch = () => {
        setIsMapModalVisible(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (editingStaff) {
            setStaff(staff.map(item =>
                item.id === editingStaff.id ? { ...formData, id: item.id } : item
            ));
            const tableSchema = '';
            const tableName = 'users';
            const conditions = {
                id: editingStaff.id
            };
            const data = {
                first_name: formData.first_name,
                last_name: formData.last_name,
                email: formData.email,
                role: formData.role,
                user_type: 'staff',
                permissions: JSON.stringify(formData.permissions),
                location: formData.location ? JSON.stringify(formData.location) : null,
                address: formData.address
            };
            const response = await oneKlicks.update(tableSchema, tableName, data, conditions);
            if (response.success) {
                alert('Staff member updated successfully');
            } else {
                console.error('Error updating staff:', response.message);
            }
        } else {
            const newStaff = {
                ...formData,
                id: Date.now(),
            };
            const tableSchema = '';
            const tableName = 'users';
            const conditions = {
                email: formData.email
            };
            const data = {
                first_name: formData.first_name,
                last_name: formData.last_name,
                email: formData.email,
                role: formData.role,
                user_type: 'staff',
                permissions: JSON.stringify(formData.permissions),
                location: formData.location ? JSON.stringify(formData.location) : null,
                address: formData.address
            };
            const response = await oneKlicks.create(tableSchema, tableName, data, conditions);
            if (response.success) {
                setStaff([...staff, newStaff]);
                alert('Staff member added successfully');
            } else {
                console.error('Error adding staff:', response.message);
            }
        }
        setIsModalVisible(false);
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Users</h5>
                                <Badge bg="info">Management</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </InputGroup>
                                <Button variant="primary" onClick={handleAdd}>+ Add User</Button>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped" >
                                    <thead>
                                            <tr>
                                            <th>ID</th>
                                            <th>Image</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Role</th>
                                            <th>Location</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {staff.map((member, index) => (
                                        <tr key={member.id}>
                                            <td data-label="ID">{index + 1}</td>
                                            <td data-label="Image">
                                                <ImageShow url={member.profile_photo_url} width={50} height={50} style={{ objectFit: 'cover', borderRadius: '50%', width: '50px', height: '50px' }} /></td>
                                            <td data-label="Name" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',  }}>{member.first_name} {member.last_name}</td>
                                            <td data-label="Email" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',  }}>{member.email}</td>
                                            <td data-label="Role" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',  }}>{member.role}</td>
                                            <td data-label="Location" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',  }}>
                                                {member.address ? (
                                                    <div className="location-cell">
                                                        <div className="location-address">{member.address}</div>
                                                        {member.location && (
                                                            <div className="location-coords">
                                                                {(() => {
                                                                    try {
                                                                        const loc = typeof member.location === 'string' 
                                                                            ? JSON.parse(member.location) 
                                                                            : member.location;
                                                                        return `${loc.lat.toFixed(4)}, ${loc.lng.toFixed(4)}`;
                                                                    } catch (e) {
                                                                        return 'Invalid coordinates';
                                                                    }
                                                                })()}
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <span className="no-location">No location set</span>
                                                )}
                                            </td>
                                            <td data-label="Actions">
                                                <div className="d-flex gap-2" style={{ flexDirection: 'row', justifyContent: 'flex-end', gap: '10px' }}>
                                                    <Button variant="primary" onClick={() => handleEdit(member)}>Edit</Button>
                                                     
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        // <div className="staff-management">
        //     <div className="row" style={{display: 'flex', justifyContent: 'space-between', marginLeft: '0px', marginRight: '-1px', padding: '31px 0px'}}>
        //         <h2>Staff Management</h2>
        //         <button className="add-button" onClick={handleAdd}>
        //             Add Staff
        //         </button>
        //     </div>

        //     <div className="staff-table-container">
        //         <table className="staff-table">
        //             <thead>
        //                 <tr>
        //                     <th>S.No</th>
        //                     <th>Name</th>
        //                     <th>Email</th>
        //                     <th>Role</th>
        //                     <th>Location</th>
        //                     <th>Permissions</th>
        //                     <th>Actions</th>
        //                 </tr>
        //             </thead>
        //             <tbody>
        //                 {staff.map((member, index) => (
        //                     <tr key={member.id}>
        //                         <td>{index + 1}</td>
        //                         <td>{member.first_name} {member.last_name}</td>
        //                         <td>{member.email}</td>
        //                         <td>{member.role}</td>
        //                         <td>
        //                             {member.address ? (
        //                                 <div className="location-cell">
        //                                     <div className="location-address">{member.address}</div>
        //                                     {member.location && (
        //                                         <div className="location-coords">
        //                                             {(() => {
        //                                                 try {
        //                                                     const loc = typeof member.location === 'string' 
        //                                                         ? JSON.parse(member.location) 
        //                                                         : member.location;
        //                                                     return `${loc.lat.toFixed(4)}, ${loc.lng.toFixed(4)}`;
        //                                                 } catch (e) {
        //                                                     return 'Invalid coordinates';
        //                                                 }
        //                                             })()}
        //                                         </div>
        //                                     )}
        //                                 </div>
        //                             ) : (
        //                                 <span className="no-location">No location set</span>
        //                             )}
        //                         </td>
        //                         <td>
        //                             {(() => {
        //                                 let perms = member.permissions;
        //                                 // If permissions is a string (e.g., '["view_dashboard","manage_doctors"]'), parse it
        //                                 if (typeof perms === 'string') {
        //                                     try {
        //                                         perms = JSON.parse(perms);
        //                                     } catch (e) {
        //                                         perms = [];
        //                                     }
        //                                 }
        //                                 return perms && perms.length
        //                                     ? perms.join(', ')
        //                                     : 'No Permissions';
        //                             })()}
        //                         </td>
        //                         <td>
        //                             <button className="edit-button" onClick={() => handleEdit(member)}>
        //                                 Edit
        //                             </button>
        //                             <button className="delete-button" onClick={() => handleDelete(member.id)}>
        //                                 Delete
        //                             </button>
        //                         </td>
        //                     </tr>
        //                 ))}
        //             </tbody>
        //         </table>
        //     </div>

        //     {isModalVisible && (
        //         <div className="modal-overlay">
        //             <div className="modal-content">
        //                 <h3>{editingStaff ? 'Edit Staff Member' : 'Add Staff Member'}</h3>
        //                 <form onSubmit={handleSubmit}>
        //                     <div className="form-group">
        //                         <label htmlFor="name">Name:</label>
        //                         <input
        //                             type="text"
        //                             id="name"
        //                             name="name"
        //                             value={formData.first_name}
        //                             onChange={handleInputChange}
        //                             required
        //                         />
        //                     </div>

        //                     <div className="form-group">
        //                         <label htmlFor="email">Email:</label>
        //                         <input
        //                             type="email"
        //                             id="email"
        //                             name="email"
        //                             value={formData.email}
        //                             onChange={handleInputChange}
        //                             required
        //                         />
        //                     </div>

        //                     <div className="form-group">
        //                         <label htmlFor="role">Role:</label>
        //                         <select
        //                             id="role"
        //                             name="role"
        //                             value={formData.role}
        //                             onChange={handleInputChange}
        //                             required
        //                         >
        //                             <option value="">Select Role</option>
        //                             <option value="admin">Admin</option>
        //                             <option value="manager">Manager</option>
        //                             <option value="staff">Staff</option>
        //                         </select>
        //                     </div>

        //                     <div className="form-group">
        //                         <label htmlFor="permissions">Permissions:</label>
        //                         <select
        //                             id="permissions"
        //                             name="permissions"
        //                             multiple
        //                             value={formData.permissions}
        //                             onChange={handlePermissionChange}
        //                             required
        //                         >
        //                             {permissions.map(permission => (
        //                                 <option key={permission.value} value={permission.value}>
        //                                     {permission.label}
        //                                 </option>
        //                             ))}
        //                         </select>
        //                     </div>

        //                     <div className="form-group">
        //                         <label htmlFor="location">Location:</label>
        //                         <div className="location-input-container">
        //                             <input
        //                                 type="text"
        //                                 id="address"
        //                                 name="address"
        //                                 value={formData.address}
        //                                 placeholder="Search for location..."
        //                                 readOnly
        //                                 className="location-input"
        //                             />
        //                             <button
        //                                 type="button"
        //                                 className="map-search-button"
        //                                 onClick={handleMapSearch}
        //                             >
        //                                 <FaMapMarkerAlt />
        //                                 Search on Map
        //                             </button>
        //                         </div>
        //                         {formData.location && (
        //                             <div className="location-info">
        //                                 <small>
        //                                     Coordinates: {formData.location.lat.toFixed(6)}, {formData.location.lng.toFixed(6)}
        //                                 </small>
        //                             </div>
        //                         )}
        //                     </div>

        //                     <div className="modal-footer" style={{padding: '15px 0px'}}>
        //                         <div className="button-group">
        //                             <button type="submit" className="submit-button">
        //                                 {editingStaff ? 'Update' : 'Add'}
        //                             </button>
        //                             <button
        //                                 type="button"
        //                                 className="cancel-button"
        //                                 onClick={() => setIsModalVisible(false)}
        //                             >
        //                                 Cancel
        //                             </button>
        //                         </div>
        //                     </div>
        //                 </form>
        //             </div>
        //         </div>
        //     )}

        //     <MapSearchModal
        //         isVisible={isMapModalVisible}
        //         onClose={() => setIsMapModalVisible(false)}
        //         onLocationSelect={handleLocationSelect}
        //         initialLocation={formData.location}
        //     />
        // </div>
    );
};

export default Users; 
